var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    [
      _c(
        "cms-heading",
        { attrs: { title: "Logger types", icon: "magicon-dots-hr" } },
        [
          _vm.userIsAdmin
            ? _c(
                "cms-button",
                {
                  attrs: {
                    color: "positive",
                    icon: "magicon-plus",
                    route: "logger-type-add",
                  },
                },
                [_vm._v("Toevoegen")]
              )
            : _vm._e(),
          _c("cms-searchbar", {
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "item-count": _vm.loggerTypes.totalCount || 0,
            "items-per-page": _vm.itemsPerPage,
            placeholder:
              !_vm.loggerTypes.items || !_vm.loggerTypes.items.length,
            clickable: _vm.userIsAdmin,
          },
          on: {
            page: function ($event) {
              _vm.offset = arguments[0]
            },
          },
        },
        [
          _c(
            "cms-table-header",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "title" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Titel")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "loggerPrice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Loggerkosten")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "failurePrice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Storingskosten")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "usagePrice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Portalkosten")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "backofficePrice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Backoffice kosten")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "manualRoundPrice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Handmeetrondekosten")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "createdAt" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Aanmaakdatum")]
              ),
              _c("cms-th"),
            ],
            1
          ),
          _vm._l(_vm.loggerTypes.items, function (type) {
            return _c(
              "tr",
              {
                on: {
                  click: function ($event) {
                    return _vm.editLoggerType(type)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(type.title))]),
                type.loggerPrice !== null
                  ? _c("td", [
                      _vm._v("€ " + _vm._s(_vm._f("number")(type.loggerPrice))),
                    ])
                  : _c("td"),
                type.failurePrice !== null
                  ? _c("td", [
                      _vm._v(
                        "€ " + _vm._s(_vm._f("number")(type.failurePrice))
                      ),
                    ])
                  : _c("td"),
                type.usagePrice !== null
                  ? _c("td", [
                      _vm._v("€ " + _vm._s(_vm._f("number")(type.usagePrice))),
                    ])
                  : _c("td"),
                type.backofficePrice !== null
                  ? _c("td", [
                      _vm._v(
                        "€ " + _vm._s(_vm._f("number")(type.backofficePrice))
                      ),
                    ])
                  : _c("td"),
                type.manualRoundPrice !== null
                  ? _c("td", [
                      _vm._v(
                        "€ " + _vm._s(_vm._f("number")(type.manualRoundPrice))
                      ),
                    ])
                  : _c("td"),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(type.createdAt, "LL"))),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm.userIsAdmin
                      ? _c("cms-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Wijzigen",
                              expression: "'Wijzigen'",
                            },
                          ],
                          attrs: {
                            icon: "magicon-edit",
                            to: {
                              name: "logger-type-edit",
                              params: { id: type.id },
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }